import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import SettingProperties from "./setting-properties-text.mdx";
import NamingTip from "./naming-tip.mdx";
import Intro from "./intro.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Intro mdxType="Intro" />
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`posthog.capture("distinct_id_of_the_user", "user_signed_up");
`}</code></pre>
    <NamingTip mdxType="NamingTip" />
    <SettingProperties mdxType="SettingProperties" />
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`posthog.capture(
    "distinct_id_of_the_user",
    "user_signed_up",
    PostHogCaptureOptions
        .builder()
        .property("login_type", "email")
        .property("is_free_trial", true)
        .build());
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      